import './app'
import './systemtagsfilelist'
import './filesplugin'
import './systemtagsinfoview'
import './css/systemtagsfilelist.scss'

window.OCA.SystemTags = OCA.SystemTags
